import { ExternalLink } from "lucide-react";
import { TIMELINE, SOURCES } from "../../lib/heritage";
import { Linkify } from "./Linkify";

export const Timeline = () => (
  <ol className="relative border-l-2 border-[color:var(--gold-hi)]/60 ml-3 md:ml-40" data-testid="history-timeline">
    {TIMELINE.map((t, i) => (
      <li key={t.year + t.title} className="relative pl-8 md:pl-12 pb-12 rise" style={{ animationDelay: `${i * 0.05}s` }} data-testid={`timeline-item-${i}`}>
        <span className="absolute -left-[10px] top-2 w-[18px] h-[18px] rounded-full bg-[#C9A227] ring-4 ring-white shadow-[0_0_10px_rgba(201,162,39,.6)]" />
        <div className="md:absolute md:-left-44 md:w-32 md:text-right font-display text-xl md:text-2xl font-bold text-[color:var(--gold)]">{t.year}</div>
        <h3 className="font-display text-xl md:text-2xl text-ink font-semibold">{t.title}</h3>
        <p className="text-sm md:text-base text-ink-3 mt-2 max-w-2xl leading-relaxed"><Linkify text={t.text} /></p>
        {t.src && SOURCES[t.src][1] && (
          <a href={SOURCES[t.src][1]} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 mt-2 font-data text-[10px] uppercase tracking-wider text-brand-green hover:text-[color:var(--gold)]" data-testid={`timeline-source-${i}`}>
            Source: {SOURCES[t.src][0]} <ExternalLink size={10} />
          </a>
        )}
      </li>
    ))}
  </ol>
);
